import { type VariantProps, cva } from 'class-variance-authority';

import { cn } from '~/styles/extended-theme';

import { Icon } from '../ui/icon';

const sizeVariant = cva('', {
  variants: {
    size: {
      sm: 'w-[200px] h-[18px] mt-[1px]',
      md: 'w-60 h-6 mt-[3px]',
      lg: 'w-80 h-8 mt-[3px]',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

type Props = {
  className?: string;
  variant?: 'light' | 'dark' | 'white' | 'black';
} & VariantProps<typeof sizeVariant>;

const getIconName = (variant: Props['variant']) => {
  switch (variant) {
    case 'white':
      return 'fp-logo-white';
    case 'black':
      return 'fp-logo-black';
    case 'dark':
      return 'fp-logo-dark';
    case 'light':
      return 'fp-logo-light';
    default:
      return 'fp-logo-light';
  }
};

export function Logo({ className, size, variant = 'light' }: Props) {
  return <Icon name={getIconName(variant)} className={cn('', sizeVariant({ size }), className)} />;
}
